import React from "react";

export const CompanyIdentity = ({ testId = "company-identity" }) => <div className="text-xs leading-relaxed text-muted-foreground" data-testid={testId}>
  <p data-testid={`${testId}-trademark`}>MarkooPlace è un marchio di EI SRL © {new Date().getFullYear()}</p>
  <p className="mt-1" data-testid={`${testId}-details`}>EI SRL · Roma, Italia · P.IVA IT16017671005</p>
</div>;
